export const fileTypes = '.jpeg, .jpg, .png, .txt, .doc, .docx, .xls, .xlsx, .pdf, .csv';

export const parseAttachedDocuments = (attachedDocuments, formValueToApi) => {
  if (attachedDocuments) {
    formValueToApi.uploadFiles = [];
    Object.keys(attachedDocuments).forEach((key) => {
      if (attachedDocuments[key] && !attachedDocuments[key].file) {
        Object.keys(attachedDocuments[key]).forEach((subKey) => {
          formValueToApi.uploadFiles.push({
            fileName: attachedDocuments[key][subKey].name,
            fileDataAsBase64: attachedDocuments[key][subKey].file,
          });
        });
      } else {
        formValueToApi.uploadFiles.push({
          fileName: attachedDocuments[key].name,
          fileDataAsBase64: attachedDocuments[key].file,
        });
      }
    });
  }
};
